import { Application } from '@features/applications';

export const sortApplicationsByDate = (applications: Application[]) =>
  applications.sort(
    (a, b) =>
      new Date(b.dt_timestamp).getTime() - new Date(a.dt_timestamp).getTime(),
  );
